import API from '../api/api'
import cloneDeep from 'lodash/cloneDeep';

const LOAD_PARTNER_TEXTS_PENDING = 'LOAD_PARTNER_TEXTS_PENDING';
const LOAD_PARTNER_TEXTS_RESPONSE = 'LOAD_PARTNER_TEXTS_RESPONSE';

const SYNC_PARTNER_TEXTS_PENDING = 'SYNC_PARTNER_TEXTS_PENDING';
const SYNC_PARTNER_TEXTS_RESPONSE = 'SYNC_PARTNER_TEXTS_RESPONSE';

const SAVE_PARTNER_TEXTS_PENDING = 'SAVE_PARTNER_TEXTS_PENDING';
const SAVE_PARTNER_TEXTS_PROGRESS = 'SAVE_PARTNER_TEXTS_PROGRESS';
const SAVE_PARTNER_TEXTS_RESPONSE = 'SAVE_PARTNER_TEXTS_RESPONSE';

const DELETE_PARTNER_INTEGRATION_PENDING = 'DELETE_PARTNER_INTEGRATION_PENDING';
const DELETE_PARTNER_INTEGRATION_RESPONSE = 'DELETE_PARTNER_INTEGRATION_RESPONSE';

const CHECK_PARTNER_INTEGRATION_PENDING = 'CHECK_PARTNER_INTEGRATION_PENDING';
const CHECK_PARTNER_INTEGRATION_RESPONSE = 'CHECK_PARTNER_INTEGRATION_RESPONSE';

const RESET_PARTNER_ERRORS = 'RESET_PARTNER_ERRORS';

const initialState = {
  load_partner_texts_pending: false,
  sync_partner_texts_pending: false,
  save_partner_texts_pending: false,
  delete_partner_pending: false,
  check_integration_pending: false,

  partner_texts: [],
  saveErrors: [],
  error: false,
  progress: 0,
  integration: null,
};

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_PARTNER_INTEGRATION_PENDING:
      return { ...state, check_integration_pending: true };
    case CHECK_PARTNER_INTEGRATION_RESPONSE:
      return {
        ...state,
        check_integration_pending: false,
        integration: action.response.success ? action.response.data : null,
      };

    case SYNC_PARTNER_TEXTS_PENDING:
      return { ...state, sync_partner_texts_pending: true };
    case SYNC_PARTNER_TEXTS_RESPONSE:
      return {
        ...state,
        sync_partner_texts_pending: false,
        partner_texts: action.response.data.entries || [],
      };

    case LOAD_PARTNER_TEXTS_PENDING:
      return { ...state, load_partner_texts_pending: true };
    case LOAD_PARTNER_TEXTS_RESPONSE:
      return {
        ...state,
        load_partner_texts_pending: false,
        partner_texts: action.response.data || [],
      };

    case SAVE_PARTNER_TEXTS_PENDING:
      return { ...state, save_partner_texts_pending: true, saveErrors: [] };
    case SAVE_PARTNER_TEXTS_PROGRESS:
      return { ...state, progress: action.progress };
    case SAVE_PARTNER_TEXTS_RESPONSE:
      return {
        ...state,
        save_partner_texts_pending: false,
        partner_texts: action.response.data || [],
      };

    case DELETE_PARTNER_INTEGRATION_PENDING:
      return { ...state, delete_partner_pending: true };
    case DELETE_PARTNER_INTEGRATION_RESPONSE:
      return {
        ...state,
        delete_partner_pending: false,
        integration: null,
        partner_texts: [],
      };

    case RESET_PARTNER_ERRORS:
      return { ...state, error: false, saveErrors: [] };

    default:
      return state;
  }
};

// ACTION CREATORS
export const resetPartnerErrors = () => (dispatch) =>
  dispatch({ type: RESET_PARTNER_ERRORS });

export const checkPartnerIntegration = (partnerName) => (dispatch) => {
  dispatch({ type: CHECK_PARTNER_INTEGRATION_PENDING });
  API.checkPartnerIntegration(partnerName, (response) => {
    dispatch({
      type: CHECK_PARTNER_INTEGRATION_RESPONSE,
      response,
    });
  });
};

export const syncPartnerTexts = (partnerName, languageId = '') => (dispatch) => {
  dispatch({ type: SYNC_PARTNER_TEXTS_PENDING });
  API.syncPartnerTexts(partnerName, languageId, (response) => {
    dispatch({
      type: SYNC_PARTNER_TEXTS_RESPONSE,
      response,
    });
  });
};

export const loadPartnerTexts = (partnerName, languageId) => (dispatch) => {
  dispatch({ type: LOAD_PARTNER_TEXTS_PENDING });
  API.getPartnerTexts(partnerName, languageId, (response) => {
    dispatch({
      type: LOAD_PARTNER_TEXTS_RESPONSE,
      response,
    });
  });
};

export const savePartnerTexts = (partnerName, languageId, data, progressCb = () => {}) => (dispatch) => {
  dispatch({ type: SAVE_PARTNER_TEXTS_PENDING });

  API.savePartnerTexts(partnerName, languageId, data, (response) => {
    dispatch({
      type: SAVE_PARTNER_TEXTS_RESPONSE,
      response,
    });
  });
};

export const deletePartnerIntegration = (partnerName) => (dispatch) => {
  dispatch({ type: DELETE_PARTNER_INTEGRATION_PENDING });
  API.deletePartnerIntegration(partnerName, (response) => {
    dispatch({
      type: DELETE_PARTNER_INTEGRATION_RESPONSE,
      response,
    });
  });
};
